<template>
<section class="app__container">
 <section class="panel__container">
    <div class="panel__wrapper panel__wrapper__a">
        <h2 class="panel__title">Ticker Builder</h2>
            <button class="line__button deleteAll" @click="handleDelete">
                <svg xmlns="http://www.w3.org/2000/svg" width="16" height="16" viewBox="0 0 16 16" fill="none">
                <mask id="mask0_1_1024" style="mask-type:luminance" maskUnits="userSpaceOnUse" x="0" y="0" width="16" height="16">
                    <path d="M16 0H0V16H16V0Z" fill="white"/>
                </mask>
                <g mask="url(#mask0_1_1024)">
                    <path d="M16 0H0V16H16V0Z" fill="white" />
                    <path d="M14.9276 8.05673L10.6396 2.36646L4.71191 6.83333L9.16698 12.3333L10.2855 11.5548L14.9276 8.05673Z" fill="white" stroke="#2B2B2B" stroke-linejoin="round"/>
                    <path d="M9.16692 12.3334L7.88743 13.3583L4.36626 13.358L3.49943 12.2077L1.35547 9.36255L4.83359 6.74162" stroke="#2B2B2B" stroke-linejoin="round"/>
                    <path d="M4.40137 13.3574L14.8546 13.3573" stroke="#2B2B2B" stroke-linecap="round"/>
                </g>
                </svg>
                <p>Clear All</p>
            </button>
            <button class="line__button uploadHTML" @click="showUploadPopup">
                <svg xmlns="http://www.w3.org/2000/svg" width="14" height="14" viewBox="0 0 14 14" fill="none">
                    <g clip-path="url(#clip0_1_1018)">
                        <path fill-rule="evenodd" clip-rule="evenodd" d="M5.88573 5.0059L7.87536 6.99554H0V7.81906H7.87536L5.88573 9.80952L6.46714 10.3918L9.45159 7.40813L6.46714 4.4245L5.88573 5.0059ZM13.6385 3.16912L11.2379 0.769358C11.0081 0.539597 10.6894 0.407837 10.365 0.407837H3.29418V5.73522H4.1177V1.23136H9.88237V4.52546H13.1765V12.7607H4.11771V9.05484H3.29419V13.5842H14V4.04288C14 3.71347 13.8715 3.40301 13.6385 3.16912H13.6385ZM10.7059 1.40184L13.006 3.70193H10.7059V1.40183V1.40184Z" fill="#2B2B2B" stroke="#2B2B2B" stroke-width="0.1"/>
                    </g>
                    <defs>
                    <clipPath id="clip0_1_1018">
                     <rect width="14" height="14" fill="white"/>
                    </clipPath>
                </defs>
                </svg>
                <p>Import</p>
            </button>
            <button class="panel__button addTicker" @click="addTicker">+ Add Ticker</button>
            <!-- <router-link to="/popup" class="panel__button navLink">Pop Up Content</router-link> -->
    </div>

    <section class="panel__wrapper panel__wrapper__b" @dragover.prevent @drop="handleDrop">
        
         <section v-for="(block, index) in store" :key="block.id" class="panel__controller" :data-label="block.type" @dragstart="handleDragStart($event, index)" @dragend="handleDragEnd">
            <Input 
            :storeId="block.id" 
            :index="index" 
            :startInEditMode="block.startInEditMode" 
            :draggable="block.isDraggable"
            @dragStart="handleDragStart($event, index)" />
        </section>
    </section>
    
  <div class="panel__wrapper panel__wrapper__c">
        <button 
            class="panel__button generateHTML" 
            :class="{ active: store.length > 0 }"
            :disabled="store.length === 0"
            @click="handleHTML"
        >
            <svg xmlns="http://www.w3.org/2000/svg" width="13" height="14" viewBox="0 0 13 14" fill="none">
            <path fill-rule="evenodd" clip-rule="evenodd" d="M7.7538 0.85107C7.77203 0.667633 7.55346 0.559297 7.41852 0.684887L1.24743 6.42843C1.13805 6.53024 1.17488 6.71167 1.31529 6.76277L5.78191 8.38849C5.8857 8.42627 5.93922 8.54104 5.90144 8.64483L4.46088 12.6028C4.39062 12.7958 4.62214 12.9566 4.77851 12.8234L12.0841 6.60011C12.2008 6.5007 12.1669 6.31236 12.0228 6.25993L7.52999 4.62466C7.4441 4.5934 7.39033 4.50789 7.39937 4.41694L7.7538 0.85107Z" stroke="white" stroke-linecap="round" stroke-linejoin="round"/>
            </svg>
            <p>Generate</p>
        </button>
  </div>
  </section>

  <section class="generatedHTML__container">
 
    <GeneratedHTML />
  </section>
  <Template />

  <!-- Upload HTML Popup -->
  <div v-if="showPopup" class="popup">
    <div class="popup-content">
      <h2 class="panel__title">Code Import</h2>
      <textarea v-model="uploadedHTML" placeholder="Paste your HTML here"></textarea>
      <div class="popup-content__cta__wrapper">
        <button class="panel__button bg_white" @click="showPopup = false">Cancel</button>
        <button class="panel__button" @click="handleUpload">Submit</button>
      </div>
    </div>
  </div>
</section>
 
</template>

<script setup>
import Input from '@/components/Input.vue'
import Template from '@/components/Template.vue'
import GeneratedHTML from '@/components/GeneratedHTML.vue'
import {template} from '@/helper/value'
import { nanoid } from 'nanoid'
import {store} from '@/helper/store'
import {generateHTML, clearCache} from '@/helper/helper'
import { ref } from 'vue';

let draggedIndex = null;
const showPopup = ref(false);
let uploadedHTML = '';

const showUploadPopup = () => {
    showPopup.value = true;
}

const handleDragStart = (event, index) => {
    if (event && event.dataTransfer) {
        draggedIndex = index;
        event.dataTransfer.effectAllowed = 'move';
    }
}

const handleDragEnd = () => {
    draggedIndex = null;
}

const handleDrop = (event) => {
    event.preventDefault();
    const dropIndex = Array.from(event.target.closest('.panel__wrapper').children).indexOf(event.target.closest('.panel__controller'));
    if (draggedIndex !== null && dropIndex !== -1) {
        const itemToMove = store.value.splice(draggedIndex, 1)[0];
        store.value.splice(dropIndex, 0, itemToMove);
    }
}

const addTicker = () => {
  const id = nanoid(10)
  store.value.unshift({...template,id})
}

const handleHTML = () => {
    generateHTML()
}

const handleDelete = () => {
    clearCache()
}

const handleUpload = () => {
    const htmlContent = uploadedHTML;
    const parser = new DOMParser();
    const doc = parser.parseFromString(htmlContent, 'text/html');
    
    const processCTALink = (link) => {
        let ctaText = '';
        let ctaValue = '';
        let checkedCTA = '';

        // Remove parent path from href
        const currentUrl = window.location.href;
        const cleanHref = link.href.replace(currentUrl, '');

        // Case 1: PDF CTA
        if (link.href.includes('/content/pdf/')) {
            checkedCTA = 'PDF';
            ctaText = link.textContent.trim();
            const pdfIndex = cleanHref.indexOf('pdf/');
            if (pdfIndex !== -1) {
                const afterPdf = cleanHref.substring(pdfIndex + 4);
                ctaValue = afterPdf.replace('?$staticlink$', '');
            }
        }
        // Case 2: Pop Up Message
        else if (link.classList.contains('promo-msg')) {
            checkedCTA = 'Pop Up Message';
            const underlineSpan = link.querySelector('.rlc-link-underline');
            ctaText = underlineSpan ? underlineSpan.textContent.trim() : '';
            
            const promoWrap = link.querySelector('.promo-wrap');
            if (promoWrap) {
                ctaValue = promoWrap.textContent.trim();
            }
        }
        // Case 3: Regular Link
        else {
            checkedCTA = 'Link';
            ctaText = link.textContent.trim();
            ctaValue = cleanHref;
        }

        const ctaId = nanoid(10);
        console.log('Created CTA with ID:', ctaId, 'Type:', checkedCTA);
        return {
            id: ctaId,
            ctaText,
            ctaValue,
            checkedCTA
        };
    };

    const processTickerItem = (item) => {
        const text = item.textContent.split('|')[0].trim();
        const lineBreak = item.innerHTML.includes('<br />');
        const links = item.querySelectorAll('a');
        const cta = Array.from(links).map(processCTALink);

        const tickerId = nanoid(10);
        console.log('Created Ticker with ID:', tickerId);
        return {
            id: tickerId,
            text,
            lineBreak,
            cta,
            hasBeenConfirmed: true // Imported tickers are considered confirmed
        };
    };

    const tickerItems = Array.from(doc.querySelectorAll('.rlc-ticker-item')).map(processTickerItem);
    console.log('All Ticker IDs:', tickerItems.map(item => item.id));
    store.value = tickerItems;
    showPopup.value = false;
    uploadedHTML = '';
}

</script>

<style>

.popup {
    position: fixed;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.5);
    display: flex;
    justify-content: center;
    align-items: center;
    z-index: 1000;
    flex-shrink: 0;
}
.popup-content {
    background-color: #fff;
    border-radius: 8px;
    padding: 2rem;
    width: 795px;
    height: 573px;
    flex-shrink: 0;
}
.popup-content .panel__title{
    margin-bottom: 1rem;
}
textarea {
    font-family: Inter;
    border-radius: 8px;
    width: 735px;
    height: 395px;
    flex-shrink: 0;
    padding: 20px 22px;
    margin-bottom: 1rem;
    border: 2px solid rgba(230, 230, 230, 0.50);
}

textarea::placeholder{
    color: #B6B6B6;

}

/* Generate button styles */
.generateHTML:disabled {
    opacity: 0.5;
    cursor: not-allowed;
    background-color: #ccc !important;
}

.generateHTML.active {
    background-color: var(--orange);
    cursor: pointer;
    transition: background-color 0.3s ease;
}

.generateHTML.active:hover {
    background-color: var(--lightOrange);
}
.popup-content__cta__wrapper{
    display: flex;
    flex-direction: row;
    justify-content: flex-end;
    gap: 1rem;
}
</style>